import classNames from 'classnames';
import { jsx as _jsx, Fragment as _Fragment } from "preact/compat/jsx-runtime";
/**
 * The Label component describes individual form fields (as a `<label>`) or fieldsets (as
 * a `<legend>`). They are built in to all form fields in the design system, but they can
 * also be used on their own to create custom fields.
 *
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/label/).
 */
export const Label = props => {
  const {
    fieldId,
    id,
    children,
    component = 'label',
    className,
    inversed,
    requirementLabel,
    labelHidden,
    ...labelProps
  } = props;
  let htmlFor = fieldId;
  if (component === 'legend' && fieldId) {
    console.warn('The `for` attribute is invalid for legends. Omitting `fieldId` from rendered element.');
    htmlFor = undefined;
  }
  const ComponentType = component;
  const classes = classNames('ds-c-label', className, inversed && 'ds-c-label--inverse');
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(ComponentType, {
      className: classes,
      htmlFor: htmlFor,
      id: id,
      "aria-hidden": labelHidden ? true : undefined,
      ...labelProps,
      children: children
    })
  });
};
export default Label;